import React from 'react';
import '../Styles/Footer.scss';
const Footer = () => {
  return (
    <footer>
    <div>
    <h2>RJS</h2>
    <p>@all right reserved</p>
    </div>
    <div>
        <h5>Thank You</h5>
        <div><a href="https://portfolio-raja-mallick.netlify.app/" target={"blank"}>Portfolio</a></div>
    </div>
    </footer>
  )
}

export default Footer
